import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { checkIfCustomerIsInternal } from "../utils/customerQueryHelpers"
import { getCustomerRevenueData } from "../utils/getCustomerRevenueData"

export const queryCustomer = {
  async customer(parent, args, context, info) {
    let { customerNumber, includeRevenue, year, internalCheck } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CUSTOMERS,
      operation: Operations.READ,
    })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customerNumber,
    })

    const customer = await getCustomer({ number: customerNumber })

    // only do this if customer was found
    if (customer?.id) {
      const { custom: customFields, defaultBillingAddressId, addresses, customerNumber } = customer
      let currentYearRevenueData = null
      let lastYearRevenueData = null
      let isInternal = false

      if (includeRevenue) {
        const { currentYearRevenue, lastYearRevenue } = await getCustomerRevenueData(customerNumber, year)
        currentYearRevenueData = currentYearRevenue
        lastYearRevenueData = lastYearRevenue
      }

      const customCustomerCharacteristics = {
        numberOfEmployees: customFields?.fields?.numberOfEmployees ?? null,
        businessVolume: customFields?.fields?.businessVolume ?? null,
        customers: customFields?.fields?.customers ?? null,
        memberships: customFields?.fields?.memberships ?? null,
        activeCompetitors: customFields?.fields?.activeCompetitors ?? null,
        foundingDate: customFields?.fields?.foundingDate ?? null,
      }

      if (internalCheck) {
        isInternal = await checkIfCustomerIsInternal({
          id: customer.id,
        })
      }

      return {
        ...customer,
        isInternal,
        customFields: {
          customerBranchId: customFields?.fields?.deliveryBranch ?? customFields?.fields?.customerBranch,
          customerClassification: customFields?.fields?.customerClassification ?? null,
          tourNumber: customFields?.fields?.tourNumber ?? null,
          admSalesRepresentive: customFields?.fields?.admSalesRepresentive ?? null,
          paymentMethod: customFields?.fields?.paymentMethod ?? null,
          einzaCreditLimit: customFields?.fields?.einzaCreditLimit ?? null,
          currentYearRevenueData,
          lastYearRevenueData,
          customerStatus: customer?.custom?.fields?.customerStatus || null,
        },
        customCustomerCharacteristics,
        defaultBillingAddress: addresses.find((address) => address?.id === defaultBillingAddressId) ?? null,
      }
    }

    return null
  },
}
